export const AddSectionIcon = ({ fill = '#001965' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5 4.17253V6.46419C17.5 7.38503 16.7542 8.13086 15.8333 8.13086H4.16667C3.24583 8.13086 2.5 7.38503 2.5 6.46419V4.17253C2.5 3.25169 3.24583 2.50586 4.16667 2.50586H15.8333C16.7542 2.50586 17.5 3.25169 17.5 4.17253Z"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5 13.5475V15.8392C17.5 16.76 16.7542 17.5059 15.8333 17.5059H4.16667C3.24583 17.5059 2.5 16.76 2.5 15.8392V13.5475C2.5 12.6267 3.24583 11.8809 4.16667 11.8809H15.8333C16.7542 11.8809 17.5 12.6267 17.5 13.5475Z"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
